export default "__VITE_ASSET__lYR0gGhK__"